import { FC, useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Space, Spin, Typography, Button, Result } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useAuth } from '../../../../context/auth';
import { getDataInStorage } from '../../../../utils/storage';
import ResendVerificationEmailButton from '../EmailVerification/ResendVerificationEmailButton';

const { Title } = Typography;

const EmailVerificationToken: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyEmail } = useAuth()
  const auth = getDataInStorage('auth');
  const [isLoading, setIsLoading] = useState(true)
  const [success, setSuccess] = useState(true);

  const isEmailVerified = auth?.user?.isEmailVerified;
  const email = searchParams.get('email');
  const newEmail = searchParams.get('newEmail');
  const token = searchParams.get('token');

  useEffect(() => {
    verifyAndNavigate();
  }, [searchParams]);

  const verifyAndNavigate = async () => {
    if (isEmailVerified && !newEmail) {
      navigate("/", { replace: true });

      return;
    }

    if (!token || !(email || newEmail)) {
      navigate('/sign-in', { replace: true });

      return;
    }

    const newSearchParams = new URLSearchParams(searchParams.toString());

    newSearchParams.delete('token');

    newSearchParams.delete('email');
    newSearchParams.delete('newEmail');
    const newRelativePathQuery = `${window.location.pathname}?${newSearchParams.toString()}`;

    window.history.replaceState(null, '', newRelativePathQuery);

    try {
      await verifyEmail({
        token,
        ...(newEmail && { newEmail })
      });

      setSuccess(true);

      setTimeout(() => {
        if (newEmail) {
          handleNavigateProfile()
        } else {
          handleNavigateToPaymentSetup()
        }
      }, 2000)
    } catch {
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigateToPaymentSetup = () => {
    navigate('/setup', { replace: true })
  }

  const handleNavigateProfile = () => {
    navigate('/profile?tab=details', { replace: true })
  }

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
        <Title level={4} style={{ paddingTop: 24, color: '#1E0C68' }}>Verifying your email...</Title>
      </div>
    );
  }

  return (
    <Space direction="vertical" size={24}>
      {success ? (
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title="Email Verified Successfully!"
        />
      ) : (
        <Result
          icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
          title="Verification Failed"
          subTitle='The verification link is invalid or expired'
          extra={
            <Space direction="vertical" size={16}>
              {email && (
                <ResendVerificationEmailButton
                  userEmail={email}
                />
              )}
              <Link to="/sign-in" replace>Back to Sign In</Link>
            </Space>
          }
        />
      )}
    </Space>
  );
};

export default EmailVerificationToken;
